import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getPantallaAll, getPantallaAllxArea, setBloqueaPantalla, setDesvinculaPantalla } from "../../services/pantalla";
import Icon from "../../Icons/general/Icon";
import IconM from "../dashboard/menu/icons/Icon";
import PantallaModal from "./pantallamodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";


function PantallaView() {
  const [Area, setArea] = useState([]);
  const [Pantalla, setPantalla] = useState([]);

  const { setShowToast, setOpciones } = ErrorContext();
  const [AreaId, setAreaId] = useState(0);
  const [AreaFId, setAreaFId] = useState(0);
  const [PantallaId, setPantallaId] = useState(0);
  const [showM, setShowM] = useState(false);
  const [tag, setTag] = useState(0);
  const [estado, setEstado] = useState("AC");
  const [selectedRow, setSelectedRow] = useState(null);
  const [page, setPage] = useState(1);
  const { slice, range } = useTable(Pantalla, page, 10);  
       
   //------ Metodo para mostrar las areas en la grilla
   const fillDispensa = async () => 
    {
      setShowToast(false);
      const response = await getPantallaAll();
      if (response) 
        {
           if (response.status === 200) 
            {
               setPantalla(response.data.data);
               setArea(response.data.area);
            } 
           else 
            {
               const Mensaje = response.message;
               const opc = { type: "Danger", message: Mensaje, active: true };
               setOpciones(opc);
               setShowToast(true);
            }
        }
    };
  
    // boton crear-Editar-Eliminar Area
    const handleCrearService = (tagId) => 
      {
         if ((selectedRow === null) && (tagId !== 0)) return
      
         if (tagId === 0) 
          {
             setAreaId(AreaFId);
             setPantallaId(0);
          }
         setShowM(true);
         setTag(tagId);
      };
  
    //---- Bloquea- Desbloquea
    const handleBloqueaService = async (tagId) => 
      {
         setShowToast(false);
         if ((selectedRow === null) ) return
         const response = await setBloqueaPantalla(AreaId, PantallaId, tagId);
         if (response) 
          {
             if (response.status === 200) 
              {
                 //setTag(0);
                 setEstado(response.data.data[0].Estado);
                 setAreaId(response.data.data[0].AreaId);
                 handleFiltrar(AreaFId);
              } 
             else 
              {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
              }
          }
      };
  
    //-----  Desvinculra Equipo
    const handleDesvincular = async () => 
      {
         setShowToast(false);
         const response = await setDesvinculaPantalla(AreaId, PantallaId);
         if (response) 
          {
             if (response.status === 200) 
              {
                 setAreaId(response.data.data[0].AreaId);
                 handleFiltrar(AreaFId);
              } 
             else 
              {
                 const Mensaje = response.message;
                 const opc = { type: "Danger", message: Mensaje, active: true };
                 setOpciones(opc);
                 setShowToast(true);
              }
          }
      }
 
 //----- al dar click en la fila
 const handlefilas = (Item, index) => 
  {
    setSelectedRow(index);
    setAreaId(Item.AreaId);
    setPantallaId(Item.PantallaId);
    setEstado(Item.Estado);
  };
    
  //------ Filtrar por area
  const handleFiltrar =async(area) =>
    {
      let response=[];
      setAreaFId(area);
      setEstado("AC");
      if (area ===0) 
       { 
        response = await getPantallaAll();
       }  
      else 
       { 
         response = await getPantallaAllxArea(area);
       }  
      if (response) 
        {
          if (response.status === 200) 
           {
             setPantalla(response.data.data);
           } 
          else 
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
           }
        }   
     }

   //--- Llamada al iniciar
   useEffect(() => 
    {
      setShowM(false);
      fillDispensa();
    }, []);
  
  return (
    <>
      <div className="">
        <div className="paneltitle">
          <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Pantalla</label>
        </div>
              
        <div className="panelmenu">
            <button className="btnmenu" onClick={() => handleCrearService(0)} >
              <IconM svg="newfile" className="iconmenu" title="newfile" />
              <span>Nuevo</span>
            </button>
            
            <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearService(1)}>
              <IconM svg="pencil" className="iconmenu" title="pencil" />
              <span>Editar</span>
            </button>
       
            <button className="btnmenu" id="Eliminar" onClick={() => handleCrearService(2)} disabled={selectedRow === null}>
              <IconM svg="delfile" className="iconmenu" title="delfile" />
              <span>Eliminar</span>
            </button>

            {estado === "AC" ? 
            (
               <button className="btnmenu" id="Bloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaService(0)}>
                   <IconM svg="lock" className="iconmenu" title="lock" />
                   <span>Bloquear</span>
                </button>
            ) : 
            (
              <button className="btnmenu" id="Desbloquear" disabled={selectedRow === null} onClick={() =>handleBloqueaService(1)}>
                 <IconM svg="dlock" className="iconmenu" title="dlock"/>
                 <span>Desbloquear</span>
              </button>
            )}

            <button className="btnmenu"  id="Desvincular" disabled={selectedRow === null} onClick={handleDesvincular}>
              <IconM svg="link" className="iconmenu" title="link"/>
              <span>Desvincular</span>
            </button>
        </div>
      </div>  
      <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
           <table className="w-full table-auto min-w-[700px]">
               <thead className="border-b border-stone-200 text-sm font-medium ">
                 <tr>
                   <th className="hidden md:table-cell px-2.5 py-2 text-start font-medium">Id.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                   <th className="px-2.5 py-2 text-start font-medium">Area</th>
                   <th className="px-2.5 py-2 text-start font-medium">
                      <span className="block lg:hidden">C. Vinc</span>
                      <span className="hidden lg:block">Codigo Vinc.</span>
                    </th>
                   <th className="px-2.5 py-2 text-start font-medium">Key Vinc.</th>
                   <th className="px-2.5 py-2 text-start font-medium">Proyectar</th>
                   <th className="px-2.5 py-2 text-start font-medium">Tipo Llamado</th>
                   <th className="px-2.5 py-2 text-start font-medium">Estado</th>
                 </tr>
               </thead>
               <tbody className="group text-sm text-stone-800 ">
                {slice.map((item, index) => {
                     return (
                       <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ConsultID}`} onClick={() => handlefilas(item, index)}>
                           <td className="hidden md:table-cell">{item.PantallaId}</td>
                           <td>{item.NombrePant}</td>
                           <td>{item.NombreArea}</td>
                           <td>{item.CodigoVinc}</td>
                           <td>{item.ClientAPKey}</td>
                           <td className="item-center justify-center text-center px-8">
                               {item.Proyecta === '1' ? 'Slider' : item.Proyecta === '2' ? 'Videos' :item.Proyecta === '3' ? 'Página Web':''}
                            </td>
                           <td>{item.Tipollamado}</td>
                           <td className="item-center">
                              {item.Estado === "AC" ? (<span className="tagac">Activo</span>) : (<span className="tagan">Suspendido</span>)}
                           </td>
                      </tr>
                    )})}
               </tbody>
             </table>
      </div>
      <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 
      <PantallaModal
        show={showM}
        AreaI={AreaId}
        AreaFId={AreaFId}
        DispensaI={PantallaId}
        Tag={tag}
        handleshow={setShowM}
        handleFiltrar={handleFiltrar}
      ></PantallaModal>
    </>
  );
}
export default PantallaView;
